import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { returnsApi, type ReturnListParams } from '../api/returns-api';

import { returnKeys } from './return-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function returnListQueryOptions(storeId: string, params: ReturnListParams) {
  return queryOptions({
    queryKey: returnKeys.list(storeId, params),
    queryFn: () => returnsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useReturns(storeId: string, params: ReturnListParams) {
  return useQuery(returnListQueryOptions(storeId, params));
}
